// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1C_jj","empty":"ModalGraph_empty__2stZX"};